import PhotoGridCard from './PhotoGridCard';

export default PhotoGridCard;
